import NotificationsOverview from './NotificationsOverview';

export default NotificationsOverview;
